import dayjs from "dayjs";
import type { TileLayerName } from "../../config/products/types";
import type { ApiW3Product } from "./types/api";
import type { W3Product } from "./types/data";

export function apiW3ProductToW3Product(
    layerName: TileLayerName,
    statusFileUrl: string,
    apiProduct: ApiW3Product,
    timeStampIsEndDate: boolean,
): W3Product {
    return {
        layerName,
        productName: apiProduct.product,
        bounds: [
            apiProduct.bounds.sw[0],
            apiProduct.bounds.sw[1],
            apiProduct.bounds.ne[0],
            apiProduct.bounds.ne[1],
        ],
        timeSteps: apiProduct.timesteps.flatMap((timestep, index, array) => {
            const nextTimestepTimestamp = array[index + 1]?.timestamp;
            const previousTimestepTimestamp = array[index - 1]?.timestamp;

            let startDate: Date | undefined;
            let endDate: Date | undefined;

            if (timeStampIsEndDate) {
                endDate = new Date(timestep.timestamp);

                if (previousTimestepTimestamp !== undefined) {
                    startDate = dayjs(previousTimestepTimestamp)
                        // +1ms to prevent overlapping time frames from step to step
                        .add(1, "millisecond")
                        .toDate();
                } else {
                    if (nextTimestepTimestamp !== undefined) {
                        const timeBetweenThisAndNextTimeStepInSeconds = dayjs(
                            nextTimestepTimestamp,
                        ).diff(timestep.timestamp, "seconds");

                        startDate = dayjs(timestep.timestamp)
                            .subtract(
                                timeBetweenThisAndNextTimeStepInSeconds,
                                "seconds",
                            )
                            // +1ms to prevent overlapping time frames from step to step
                            .add(1, "millisecond")
                            .toDate();
                    }
                }
            } else {
                startDate = new Date(timestep.timestamp);

                if (nextTimestepTimestamp !== undefined) {
                    endDate = dayjs(nextTimestepTimestamp)
                        // -1ms to prevent overlapping time frames from step to step
                        .subtract(1, "millisecond")
                        .toDate();
                } else {
                    if (previousTimestepTimestamp !== undefined) {
                        const timeBetweenThisAndPrevTimeStepInSeconds = dayjs(
                            timestep.timestamp,
                        ).diff(previousTimestepTimestamp, "seconds");

                        startDate = dayjs(timestep.timestamp)
                            .add(
                                timeBetweenThisAndPrevTimeStepInSeconds,
                                "seconds",
                            )
                            // -1ms to prevent overlapping time frames from step to step
                            .subtract(1, "millisecond")
                            .toDate();
                    }
                }
            }

            if (startDate === undefined || endDate === undefined) return [];

            return {
                startDate,
                endDate,
                tileUrl: apiProduct.tilesBaseUrl + timestep.tiles,
            };
        }),
        run: new Date(apiProduct.runDate),
        intensityBarApiUrlTemplate: apiProduct.pointApiUrlTemplate,
        debug: {
            ...(apiProduct.debug?.source !== null &&
            apiProduct.debug?.source !== undefined
                ? { source: apiProduct.debug.source }
                : {}),
        },
        statusFileUrl,
        ...(apiProduct.tempNoData !== null
            ? {
                  dataTemporaryNotAvailableVectorTilesUrlTemplate:
                      apiProduct.tilesBaseUrl + apiProduct.tempNoData,
              }
            : {}),
    };
}
